export const TOAST = {
	DEFAULT_DURATION_MS: 5000,
	EXIT_ANIMATION_MS: 200,
	EXIT_TRIGGER_OFFSET_MS: 300,
	CLOSE_ARIA: 'Fechar notificação',
	PORTAL_ARIA: 'Notificações'
} as const;
